import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classnames from 'classnames';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import NoPagesIcon from 'components/Icons/NoPages';
import CreatingFilesIcon from 'components/Icons/CreatingFiles';

interface Props {
  className?: string;
  migrationInProgress?: boolean;
  shouldRenderButton?: boolean;
  onClick: () => void;
}

function NoPagesView({
  className,
  migrationInProgress = false,
  shouldRenderButton = false,
  onClick,
}: Props) {
  const classes = useStyles();
  const title = migrationInProgress ? 'Pages are being created' : 'No pages exist yet';
  const buttonTitle = migrationInProgress ? 'Reload' : 'New Pages';
  const subtitle = migrationInProgress
    ? 'Your pages are being created from an existing attribute, check back in a few minutes'
    : "You haven't created any pages yet. You can create pages by...";

  const icon = migrationInProgress ? (
    <CreatingFilesIcon
      data-testid="creating-files-icon"
      className={classnames(classes.creatingFilesIcon, classes.marginBottom)}
    />
  ) : (
    <NoPagesIcon
      data-testid="no-pages-icon"
      className={classnames(classes.noResultsIcon, classes.marginBottom)}
    />
  );
  const NewPagesButton = (
    <Button disabled={!shouldRenderButton} variant="outlined" color="secondary" onClick={onClick}>
      {buttonTitle}
    </Button>
  );

  return (
    <Card classes={{ root: classes.noResultsCard }} className={className}>
      <CardContent classes={{ root: classes.noResultsCardContent }}>
        {icon}
        <Typography className={classnames(classes.marginBottom, classes.title)}>{title}</Typography>
        <Typography className={classes.marginBottom} variant="subtitle2">
          {subtitle}
        </Typography>
        {shouldRenderButton ? (
          NewPagesButton
        ) : (
          <Tooltip
            data-testid="tooltip"
            title="Your pages are being automatically managed via data sync"
            placement="top"
            arrow={true}
          >
            <div data-testid="disabled-new-pages-button">{NewPagesButton}</div>
          </Tooltip>
        )}
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles((theme: any) => ({
  noResultsCard: {
    marginTop: theme.spacing(3),
  },
  noResultsCardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 400,
    justifyContent: 'center',
  },
  creatingFilesIcon: {
    width: 204,
    height: 211,
  },
  noResultsIcon: {
    width: 204,
    height: 211,
  },
  marginBottom: {
    marginBottom: theme.spacing(3),
  },
  title: {
    ...theme.typography.body1bold,
  },
}));

export default NoPagesView;
